import React, { useEffect, useState } from 'react';

const WelcomeAnimation = ({ firstName, onAnimationComplete }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    // Masquer l'animation après 2 secondes et appeler le callback
    const timer = setTimeout(() => {
      setShow(false);
      if (onAnimationComplete) {
        onAnimationComplete();
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [onAnimationComplete]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className="text-center">
        <h1 className="text-6xl md:text-8xl font-bold mb-4 animate-fade-in-up bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 text-transparent bg-clip-text">
          Content de vous revoir
        </h1>
        <p className="text-4xl md:text-6xl animate-fade-in-up-delay bg-gradient-to-r from-blue-400 via-purple-400 to-indigo-400 text-transparent bg-clip-text font-bold">
          {firstName}
        </p>
      </div>
    </div>
  );
};

export default WelcomeAnimation; 